module.exports = __webpack_public_path__ + "static/05-e93703ad89113e2abd33cbb0d0ea8976.png";